import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { CopyButtonProps } from '../types';

const CopyButton = ({ text }: CopyButtonProps) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    let success = false;

    if (navigator.clipboard) {
      try {
        await navigator.clipboard.writeText(text);
        success = true;
      } catch {
        success = false;
      }
    }

    if (!success) {
      try {
        const textarea = document.createElement('textarea');
        textarea.value = text;
        textarea.style.cssText = 'position:fixed;top:-9999px;left:-9999px;opacity:0';
        document.body.appendChild(textarea);
        textarea.select();
        success = document.execCommand('copy');
        document.body.removeChild(textarea);
      } catch {
        success = false;
      }
    }

    if (success) {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <button
      type="button"
      className={`message-copy-btn${copied ? ' copied' : ''}`}
      onClick={handleCopy}
      title={copied ? t('assistant.copied') : t('assistant.copy')}
    >
      <i className={`ti ${copied ? 'ti-check' : 'ti-copy'}`} />
    </button>
  );
};

export default CopyButton;
